import { create } from "zustand";

export type ShellRevealPhase = "idle" | "holding" | "revealing";

interface ShellRevealStore {
  phase: ShellRevealPhase;
  setPhase: (phase: ShellRevealPhase) => void;
}

export const useShellRevealStore = create<ShellRevealStore>()(set => ({
  phase: "idle",
  setPhase: phase => set({ phase }),
}));
